module.exports = __webpack_public_path__ + "img/stock1.872790a5.png";